import { AvailableStepsInNavigationBar, NavigationBarItem, RouteIds } from '../types';
import { Flows } from '@lx/quote-tool/lite/shared/types';

/**
 * From the base navigation bar items, it fills the rest of the properties accordingly with the needs of each step.
 *
 * This function is used to fill the navigation bar items for the quote steps in the quote tool.
 * For active flow `aya`, it uses `RouteIds.ayaQuote`, otherwise it uses `RouteIds.quote`.
 *
 * @param activeFlow the active flow.
 * @param baseNavigationBarItems the base navigation bar items.
 */
export const getQuoteStepsNavigationBarItems = (
  activeFlow: string,
  baseNavigationBarItems: Record<AvailableStepsInNavigationBar, NavigationBarItem>,
): Record<AvailableStepsInNavigationBar, NavigationBarItem> => {
  const filledNavigationBarItems = { ...baseNavigationBarItems };

  // Fill extra properties
  filledNavigationBarItems[RouteIds.course] = {
    ...filledNavigationBarItems[RouteIds.course],
    icon: 'check',
    disabled: true,
  };

  if (activeFlow !== Flows.Online) {
    filledNavigationBarItems[RouteIds.extras] = {
      ...filledNavigationBarItems[RouteIds.extras],
      icon: 'check',
      disabled: true,
    };
  }

  filledNavigationBarItems[RouteIds.applicant] = {
    ...filledNavigationBarItems[RouteIds.applicant],
    icon: 'check',
    disabled: true,
  };

  if (activeFlow === Flows.Aya) {
    filledNavigationBarItems[RouteIds.ayaQuote] = {
      ...filledNavigationBarItems[RouteIds.ayaQuote],
    };
  } else {
    filledNavigationBarItems[RouteIds.quote] = {
      ...filledNavigationBarItems[RouteIds.quote],
    };
  }

  return filledNavigationBarItems;
};

/**
 * It customizes the quote step navigation bar item based on the active flow and return a new record of navigation bar items.
 *
 * This function is used to disable the quote step in the navigation bar when the user is in the quote step.
 * It will disable the quote step for both `aya` and `quote` flows.
 *
 * @param activeFlow the active flow, which can be either `aya` or `quote`.
 * @param baseNavigationBarItems the base navigation bar items.
 */
export const customizeQuoteStepNavigationBarItem = (
  activeFlow: string,
  baseNavigationBarItems: Record<AvailableStepsInNavigationBar, NavigationBarItem>,
): Record<string, NavigationBarItem> => {
  const routeId = activeFlow === Flows.Aya ? RouteIds.ayaQuote : RouteIds.quote;
  return {
    [routeId]: {
      ...baseNavigationBarItems[routeId],
      disabled: true,
    },
  };
};
